import React, { Fragment } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { REMAINING_STOCK_LIMIT } from 'Components/utils/accommodation/accommodation.utils';
import { themes } from './AccommodationRoomAvailability.themes';
type Props = {
  className?: string;
  isCabin?: boolean;
  stock: number;
  theme: keyof typeof themes;
};
export const AccommodationRoomAvailability = ({
  className,
  isCabin = false,
  stock = REMAINING_STOCK_LIMIT + 1,
  theme = 'default',
}: Props) => {
  const isLast = stock <= REMAINING_STOCK_LIMIT;
  const { thIconLastSize, thIconSize, thLastLabel, thRoot, thStock } = themes[theme];
  return (
    <p className={classnames(thRoot, className)}>
      {isLast ? (
        <Fragment>
          {stock > 1 && (
            <span className={thLastLabel}>
              {isCabin
                ? t('booking.accommodation.lastAvailabilityCabins')
                : t('booking.accommodation.lastAvailability')}
            </span>
          )}
          <span className={thStock}>
            <Icon name={ICONS.WARNING} width={thIconLastSize} />
            {stock === 1
              ? t('booking.accommodation.moreRooms.lastAvailability')
              : t('booking.accommodation.roomAvailabilities', {
                  numberOfRoomsLeft: stock,
                })}
          </span>
        </Fragment>
      ) : (
        <Fragment>
          {t('booking.accommodation.available')}
          <Icon name={ICONS.CHECK} width={thIconSize} />
        </Fragment>
      )}
    </p>
  );
};
